export default __webpack_public_path__ + "static/media/wrench.6d2f8a91.webp";